<div class="container">
  <div class="player-wrapper" *ngIf="srcParam">
    <amaze-player #player
      src="assets/bancolombia.amz"
      audioSrc="assets/music.mp3"
      [audioLoop]=false
      orientation="portrait"
      [data]="{
        nombre: 'María',
        fecha: '31/05/2025',
        genero: 1,
        tarjeta: 3,
        button: buttonHandler
      }"
      [autoplay]=true
    >
    </amaze-player>
  </div>
</div>